export const onboardPhase = {
	1: "Onboarding",
	2: "Ongoing"
};

export const onboardPhaseType = {
	Onboard: 1,
	Ongoing: 2
};

export const onboardTouch = {
	low: "LOW",
	mid: "MID",
	high: "HIGH",
	enterprise: "ENTERPRISE"
};
